import { useTranslation } from 'react-i18next'
import { Experiment, Variant } from 'react-optimize'

type Props = {
    children: string
}

const LocaleAbTest = ({ children }: Props) => {
    const { t } = useTranslation()

    return (
        <Experiment id="V_dqIuT4S4ims-29Fo4leQ">
            <Variant id="0">{children}</Variant>
            <Variant id="1">{t(children)}</Variant>
        </Experiment>
    )
}

export default LocaleAbTest
